import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M11 3.6a7.4 7.4 0 1 0 5.159 12.706.607.607 0 0 1 .146-.147A7.4 7.4 0 0 0 11 3.6Zm6.49 13.042a8.6 8.6 0 1 0-.849.849l3.935 3.933a.6.6 0 0 0 .848-.848l-3.933-3.934ZM11 7.4a.6.6 0 0 1 .6.6v2.4H14a.6.6 0 1 1 0 1.2h-2.4V14a.6.6 0 1 1-1.2 0v-2.4H8a.6.6 0 1 1 0-1.2h2.4V8a.6.6 0 0 1 .6-.6Z"
      clip-rule="evenodd"
    />
  </svg>
`;
